export async function traverseDataTransferItems(items) {
  const all = [];

  const walk = (entry, relativeDir) =>
    new Promise((resolve) => {
      if (entry.isFile) {
        entry.file(
          (file) => {
            all.push({ file, sourcePath: buildSourcePath(relativeDir) });
            resolve();
          },
          () => resolve()
        );
        return;
      }
      if (entry.isDirectory) {
        const reader = entry.createReader();
        const collected = [];
        const readChunk = () => {
          reader.readEntries(
            async (entries) => {
              if (entries.length === 0) {
                const nextDir = (relativeDir ? relativeDir + '/' : '') + entry.name;
                await Promise.all(collected.map((c) => walk(c, nextDir)));
                resolve();
                return;
              }
              collected.push(...entries);
              readChunk();
            },
            () => resolve()
          );
        };
        readChunk();
        return;
      }
      resolve();
    });

  const walks = [];
  for (const item of items) {
    const entry = typeof item.webkitGetAsEntry === 'function' ? item.webkitGetAsEntry() : null;
    if (entry) {
      walks.push(walk(entry, ''));
    } else if (item.kind === 'file') {
      const file = item.getAsFile();
      if (file) all.push({ file, sourcePath: null });
    }
  }
  await Promise.all(walks);
  return all;
}

export function filesFromInput(fileList, useWebkitRelativePath) {
  const arr = [];
  for (const file of fileList) {
    const relative = useWebkitRelativePath ? file.webkitRelativePath || '' : '';
    const sourcePath = relative ? buildSourcePath(stripFilename(relative)) : null;
    arr.push({ file, sourcePath });
  }
  return arr;
}

function buildSourcePath(relativeDir) {
  if (!relativeDir) return null;
  return '/' + relativeDir.replace(/^\/+|\/+$/g, '') + '/';
}

function stripFilename(relative) {
  const idx = relative.lastIndexOf('/');
  return idx >= 0 ? relative.slice(0, idx) : '';
}
